import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { DinoProfileNFT } from '@jdiyield/abi';
import { DINO_PROFILE_NFT } from '@jdiyield/constants';
import Web3 from 'web3';
import getNodeUrl from './rpcRandom';
export var getTokenURI = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenId) {
    var web3, contract, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            web3 = new Web3(getNodeUrl(56));
            contract = new web3.eth.Contract(DinoProfileNFT, DINO_PROFILE_NFT);
            _context.next = 5;
            return contract.methods.tokenURI(tokenId).call();

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function getTokenURI(_x) {
    return _ref.apply(this, arguments);
  };
}();